// Vendors
import React, { useCallback } from 'react'
import { useForm } from 'react-hook-form'

// Components
import { FieldTextArea } from 'components/FieldTextArea'

// Styles
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useError } from 'hooks/useError'
import { apiPatch } from 'services/patch'

type ModalCancelOrderProps = {
  isOpen: boolean
  reload: () => void
  purchaseId: string
  onCancel: () => void
}

type FormCancelOrder = {
  comments: string
}

export const ModalCancelOrder = (props: ModalCancelOrderProps) => {
  const { isOpen, reload, onCancel, purchaseId } = props

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormCancelOrder>()

  const { handleError } = useError()

  const onClose = useCallback(() => {
    reset()
    onCancel()
  }, [onCancel, reset])

  const onSubmit = useCallback(
    async (data: FormCancelOrder) => {
      try {
        // TODO: Add your logic here

        await apiPatch(`/app/purchase/${purchaseId}/cancel_order`, {
          comments: data.comments,
        })

        reload()
        onClose()
      } catch (error) {
        handleError(error)
      }
    },
    [handleError, onClose, purchaseId, reload]
  )

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader>Cancelar pedido</ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <Text color="gray.500" mb="4">
            Para cancelar e remover o pedido, por favor preencha os campos
            abaixo:
          </Text>

          <Stack>
            <FieldTextArea
              label="Justificativa"
              error={errors.comments}
              placeholder="Digite uma justificativa"
              {...register('comments', {
                required: 'Por favor, preencha o campo de justificativa',
              })}
            />
          </Stack>

          <Text fontSize="sm" color="orange.500" mt="4" fontStyle="italic">
            Cancelar um pedido implica no cancelamento de TODOS os kits
            associados a ele. Essa operação é irreversível.
          </Text>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button onClick={onClose}>Cancelar</Button>
            <Button type="submit" colorScheme="blue" isLoading={isSubmitting}>
              Confirmar
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
